module.exports = __webpack_public_path__ + "assets/img/apply_refund.cd0290b0.png";